import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Dynamic } from '@shared/registry/dynamic';

import { type ProgressBarConfig } from './progress-bar.types';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.html',
  imports: [Dynamic],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBar {
  readonly config = input.required<ProgressBarConfig>();

  protected readonly isCompleted = computed(() => this.config().state === 'completed');
  protected readonly progressPercent = computed(() => Math.min(100, Math.max(0, this.config().progress)));

  // Label above progress bar
  protected readonly labelConfig = computed(() => ({
    text: this.config().label,
    size: 'sm' as const,
    fontWeight: 'bold' as const,
    fontFamily: 'var(--progressbar-font-family)',
    cssVarPrefix: 'progressbar-label',
  }));

  protected readonly startLabelConfig = computed(() => ({
    text: this.config().startLabel,
    size: 'sm' as const,
    fontWeight: 'bold' as const,
    color: this.isCompleted() ? 'var(--progressbar-label-idle-color)' : 'var(--progressbar-label-active-color)',
    fontFamily: 'var(--progressbar-font-family)',
    cssVarPrefix: 'progressbar-start-label',
  }));

  protected readonly endLabelConfig = computed(() => ({
    text: this.config().endLabel,
    size: 'sm' as const,
    fontWeight: 'bold' as const,
    color: this.isCompleted() ? 'var(--progressbar-label-active-color)' : 'var(--progressbar-label-idle-color)',
    fontFamily: 'var(--progressbar-font-family)',
    cssVarPrefix: 'progressbar-end-label',
  }));
}
